import NotFoundError from '@/common/errors/not-found-error'
import HttpClient from '@/common/lib/http-client'
import { IPost, Post } from '@/common/models/data/dashboard/posts/post'
import { IPaginatedResponse, PaginatedResponse } from '@/common/models/data/common/pagination/paginated-response'
import { SignedRouteParams } from '@/common/models/signed-route-params'
import { IPostShowResponse, PostShowResponse } from '@/common/models/responses/post-show-response'

import { blog as Api } from '@/app/api'

class BlogRepository {
    private static errorTag = 'BlogRepository'

    async byCategory (categorySlug: string, page = 1): Promise<PaginatedResponse<Post>> {
        const response = await HttpClient.getJson<IPaginatedResponse<IPost>>(Api.byCategory(categorySlug, page))

        if (response.meta.current_page > response.meta.last_page) {
            throw new NotFoundError(BlogRepository.errorTag)
        }

        return PaginatedResponse.fromInterface(response, (dto): Post => {
            return new Post(dto)
        })
    }

    async bySlug (slug: string, params?: SignedRouteParams): Promise<PostShowResponse> {
        const response = await HttpClient.getJson<IPostShowResponse>(Api.bySlug(slug, params))

        return new PostShowResponse(response)
    }

    async index (page = 1, notPublished = false, categorySlug?: string): Promise<PaginatedResponse<Post>> {
        const response = await HttpClient.getJson<IPaginatedResponse<IPost>>(Api.index(page, notPublished, categorySlug))

        if (response.meta.current_page > response.meta.last_page) {
            throw new NotFoundError(BlogRepository.errorTag)
        }

        return PaginatedResponse.fromInterface(response, (dto): Post => {
            return new Post(dto)
        })
    }
}

export default new BlogRepository()
